import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * A learner's course progress changed — pushed to managers as it happens
 * (`ProgressBroadcastService` in howio-server). Kept as a short feed for the
 * workflow map's learner numbers: "Happening now", and the step a learner just
 * moved onto.
 */
export interface ILearnerMove {
  courseProgressId: number;
  courseId: number;
  name: string;
  /** Where their progress sits now. */
  courseNodeId: number | null;
  /** Where it sat before, when this tab held the progress already. */
  fromCourseNodeId: number | null;
  status: number;
  score: number | null;
  at: number;
}

export interface ILiveCourseState {
  moves: ILearnerMove[];
}

const KEEP = 20;

const initialState: ILiveCourseState = { moves: [] };

const liveCourseSlice = createSlice({
  name: 'liveCourse',
  initialState,
  reducers: {
    learnerMoved(state, action: PayloadAction<ILearnerMove>) {
      state.moves = [action.payload, ...state.moves].slice(0, KEEP);
    },
  },
});

export const { learnerMoved } = liveCourseSlice.actions;

export default liveCourseSlice.reducer;
